/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ThermoformingInsole } from '../../models/thermoforming-insole';

export interface MgmtThermoformingInsoleControllerSortDown$Params {
  id: number;
}

export function mgmtThermoformingInsoleControllerSortDown(http: HttpClient, rootUrl: string, params: MgmtThermoformingInsoleControllerSortDown$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsole>> {
  const rb = new RequestBuilder(rootUrl, mgmtThermoformingInsoleControllerSortDown.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThermoformingInsole>;
    })
  );
}

mgmtThermoformingInsoleControllerSortDown.PATH = '/api/mgmt/thermoforming-insole/{id}/sort-down';
